<template>
  <div class="bgimg">
    <div class="bigbox">
      <div class="login-title">刘湾零工市场</div>
      <div class="login-right">
        <div class="loginType">
          <div
            :class="loginType == 'account' ? 'active' : 'common'"
            @click="switchType('account')"
          >
            账号登录
          </div>
          <div
            :class="loginType == 'phone' ? 'active' : 'common'"
            @click="switchType('phone')"
          >
            手机号登录/注册
          </div>
        </div>
        <div class="loginInput" v-if="loginType == 'account'">
          <div class="login-item">
            <el-input
              v-model="userPhone"
              placeholder="输入手机号"
              maxlength="20"
            >
              <div slot="prefix">
                <img src="../assets/img/phone.png" class="login-input" />
              </div>
            </el-input>
          </div>
          <div class="login-item">
            <el-input
              show-password
              v-model="userPassword"
              placeholder="密码"
              maxlength="20"
              @keyup.enter.native="login"
            >
              <div slot="prefix">
                <img src="../assets/img/pas.png" class="login-input" />
              </div>
            </el-input>
          </div>
          <div class="login-remember" @click="goFindPassword">找回密码</div>
        </div>
        <div class="loginInput" v-if="loginType == 'phone'">
          <div class="login-item">
            <el-input v-model="phone" placeholder="输入手机号" maxlength="20">
              <div slot="prefix">
                <img src="../assets/img/phone.png" class="login-input" />
              </div>
            </el-input>
          </div>
          <div class="login-item">
            <el-input
              show-password
              v-model="smsCode"
              placeholder="短信验证码"
              maxlength="20"
            >
              <div slot="prefix">
                <img src="../assets/img/pas.png" class="login-input" />
              </div>
            </el-input>
            <div class="login-yan" @click="getPhoneCode">
              <div>{{ codeButtonText }}</div>
            </div>
          </div>
          <div class="login-item">
            <el-input
              v-model="code"
              placeholder="图形验证码"
              maxlength="6"
              @keyup.enter.native="login"
            >
              <div slot="prefix">
                <img src="../assets/img/yan.png" class="login-input" />
              </div>
            </el-input>
            <div class="login-yan">
              <img :src="codeUrl" alt="" @click="geturl" />
            </div>
          </div>
        </div>
        <div class="login-but" @click="login">登录</div>
        <div class="agreement">
          <span>登录即代表您已同意</span>
          <span @click="pushRule">《服务协议和隐私协议》</span>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showText" :title="company_privacy_agreement.ruleTitle" class="qrcodeDialog" width="500px">
      <div style="height: 600px;overflow-y: auto;" v-html="company_privacy_agreement ? company_privacy_agreement.ruleContent : ''">
      </div>
    </el-dialog>
    <!-- 底部备案信息（优化样式） -->
    <div class="footer" style="position: absolute; bottom: 0; left: 0; width: 100%; text-align: center; padding: 15px 0; color: #999; font-size: 12px; ">
      <a href="https://beian.miit.gov.cn/" target="_blank" style="text-decoration: none; color: #999; transition: color 0.3s;">豫ICP备2022011076号-5</a>
    </div>
  </div>
</template>
<script>
export default {
  phone: "log",
  data() {
    return {
      userPhone: "",
      userPassword: "",
      phone: "",
      pass: "",
      code: "",
      codeUrl: "",
      uuid: "",
      isRemember: false,
      loginType: "account",
      smsCode: "",
      codeButtonText: "发送验证码",
      showText:false,
      company_privacy_agreement:''
    };
  },
  mounted() {
    this.phone = localStorage.getItem("phone") || "";
    this.pass = localStorage.getItem("pass") || "";
    this.isRemember = this.phone && this.pass;
    this.geturl();
  },
  methods: {
    pushRule(){
      // this.changeRegion()
      this.showText = true
      this.$get("/api/common/selectRuleByType", {
        ruleType: 'company_privacy_agreement',
      }).then((res) => {
        this.company_privacy_agreement = res.data
      });
    },
    goFindPassword() {
      this.$router.push("/forgetPassword");
    },
    switchType(type) {
      this.loginType = type;
    },
    getPhoneCode() {
      // console.log(this.phone);
      if (this.codeButtonText == "重新发送" ||this.codeButtonText == "发送验证码") {
        this.$post("/api/common/sendSmsCode", {
          phone: this.phone,
        }).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "验证码已发送，请注意查收！",
              type: "success",
            });
            let count = 60; // 设置倒计时时间（单位：秒）

            this.codeButtonText = `${count}s`; // 更新按钮显示的文本

            const timer = setInterval(() => {
              count--;

              if (count <= 0) {
                clearInterval(timer); // 清除计时器
                this.codeButtonText='重新发送'; // 复原按钮状态
              } else {
                this.codeButtonText = `${count}s`; // 更新按钮显示的文本
              }
            }, 1000);
          }
        });
      }
    },
    geturl() {
      this.$get("/api/common/captchaImage", {}).then((res) => {
        this.codeUrl = "data:image/gif;base64," + res.img;
        this.uuid = res.uuid;
        this.code = "";
      });
    },
    login() {
      if (this.loginType == "account") {
        this.$post("/api/company/companyUser/companyUserLogin", {
          userPhone: this.userPhone,
          userPassword: this.userPassword,
        })
          .then((res) => {
            this.$cookie.set("companyUserId", res.data.Authorization, {
              expires: 1,
            });
            this.$router.push({ path: "/" });
          })
          .catch((err) => {
            this.geturl();
          });
      } else if (this.loginType == "phone") {
        this.$post("/api/company/companyUser/companyUserLoginOrRegister", {
          userPhone: this.phone,
          smsCode: this.smsCode,
          uuid: this.uuid,
          code: this.code,
        })
          .then((res) => {
            this.$cookie.set("companyUserId", res.data.Authorization, {
              expires: 1,
            });
            this.$router.push({ path: "/" });
          })
          .catch((err) => {
            this.geturl();
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bgimg {
  background: url(../assets/img/loginbg.png) no-repeat;
  background-size: 100% 100%;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: cover;
}

.bigbox {
  width: 600px;
  height: 600px;
  position: absolute;
  left: 150px;
  top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .login-title {
    width: 600px;
    height: 70px;
    margin-bottom: 26px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 40px;
    color: #ffffff;
    line-height: 70px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }

  .login-right {
    width: 360px;
    height: 360px;
    background: #ffffff;
    box-shadow: 0px 2px 20px 1px rgba(0, 0, 0, 0.11);
    border-radius: 20px;
    padding: 35px;

    .loginType {
      display: flex;
      margin-bottom: 20px;
      .active {
        height: 37px;
        margin-right: 30px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 26px;
        color: #0051aa;
        line-height: 0px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }

      .common {
        height: 28px;
        margin-right: 30px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #9d9d9d;
        line-height: 0px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }
    }

    .login-item {
      width: 360px;
      height: 50px;
      border-radius: 2px;
      margin-bottom: 20px;
      display: flex;

      .login-input {
        width: 22px;
        height: 22px;
        margin: 18px 8px 0 10px;
      }

      & ::v-deep .el-input--prefix .el-input__inner {
        height: 60px;
        padding-left: 44px;
        font-size: 22px;
      }

      & ::v-deep .el-input__inner:focus {
        border-color: #176449;
      }

      .login-yan {
        width: 158px;
        height: 60px;
        flex-shrink: 0;
        margin-left: 12px;
        cursor: pointer;
        div {
          width: 150px;
          height: 60px;
          background: #0051aa;
          border-radius: 2px 2px 2px 2px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #ffffff;
          line-height: 60px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .login-remember {
      width: 360px;
      height: 60px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #0051aa;
      line-height: 30px;
      text-align: right;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
    }

    .login-but {
      width: 360px;
      height: 62px;
      margin-top: 10px;
      background: #0051aa;
      border-radius: 2px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 26px;
      color: #ffffff;
      line-height: 62px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
    }
    .agreement {
      margin-top: 20px;
    }
    .agreement > span:nth-of-type(1) {
      width: 180px;
      height: 28px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #3d3d3d;
      line-height: 0px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .agreement > span:nth-of-type(2) {
      width: 220px;
      height: 28px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #0051aa;
      line-height: 0px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
    }
  }
}
</style>

<style>
.qrcodeDialog .el-dialog,
.el-dialog__wrapper .el-dialog {
  margin-top: 5vh !important;
}
</style>